<template>
    <div class="wrapper" v-bind:class="[data.isSelected ? 'selected' : '', data.highlight]" v-on:mousemove="onMouseMove" v-on:mouseup="onMouseUp">
        <div class="obstacle" v-if="data.obstacle"
            v-on:mouseenter="showTooltip = true"
            v-on:mouseleave="showTooltip = false"
            v-on:click="removeObstacle(col, row)"
        >
            <img v-bind:src="'images/obstacles/' + data.obstacle.icon" />
            <div class="tooltip-spacer">
                <div class="item-tooltip" v-show="showTooltip">
                    {{data.obstacle.name}}<br />
                    <small v-html="data.obstacle.description" />
                </div>
            </div>
        </div>
        <div v-if="!data.obstacle">
            <div v-if="data.number == 0" class="pencil inner">{{data.innerPencils.join('')}}</div>
            <div v-if="data.number == 0" class="pencil outer">{{data.outerPencils.join('')}}</div>
            <div v-bind:class="[isGiven, textHighlight]" class="mainText">{{data.conflictNumber ? data.conflictNumber : displayNumber}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sudoku-cell',
        props: {
            data: {
                type: Object,
                required: true
            },
            removeObstacle: {
                type: Function
            },
            row: {
                type: Number
            },
            col: {
                type: Number
            }
        },
        data() {
            return {
                showTooltip: false
            }
        },
        computed: {
            displayNumber: function() {
                return this.data.number > 0 ? this.data.number : "";
            },
            isGiven: function () {
                return this.data.isGiven ? "given" : "";
            },
            textHighlight: function() {
                return this.data.conflictNumber ? "redText" : this.data.textHighlight;
            }
        },
        methods: {
            onMouseMove: function(event) {
                if(event.buttons > 0) {
                    this.data.isSelected = !event.ctrlKey && !this.data.obstacle;
                }
            },
            onMouseUp: function(event) {
                this.data.isSelected = !event.ctrlKey  && !this.data.obstacle;
            }
        }
    }
</script>

<style scoped>
@media all and (max-width: 1670px) {
    .mainText {
        font-size: 15pt;
        position: absolute;
        top: 8px;
        left: 17px;
    }
    .obstacle img {
        width: 42px;
        height: 42px;
    }
    .pencil {
        font-size: 7pt;
        font-weight: bold;
    }
    .outer {
        width: 35px;
        position: absolute;
        word-break: break-all;
        margin-left: auto;
        margin-right: auto;
        color:maroon;
        left: 4px;
    }
    .inner {
        width: 35px;
        word-break: break-all;
        margin-left: auto;
        margin-right: auto;
        color: steelblue;
        position: absolute;
        top: 20px;
        left: 4px;
    }
}

@media all and (min-width: 1671px) {
    .mainText {
        font-size: 20pt;
        position: absolute;
        top: 14px;
        left: 24px;
    }
    .obstacle img {
        width: 62px;
        height: 62px;
    }
    .pencil {
        font-size: 8pt;
    }
    .outer {
        position: absolute;
        color:maroon;
    }
    .inner {
        width: 30px;
        word-break: break-all;
        margin-left: auto;
        margin-right: auto;
        color: steelblue;
        position: absolute;
        top: 17px;
        left: 17px;
    }
}
div.wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    vertical-align: middle;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none; 
    user-select: none; 
}
.orange {
    background-color: rgba(255, 223, 190, .6);
}
.green {
    background-color: rgba(225, 255, 192, .5);
}
.blue {
    background-color:rgba(201, 243, 255, .6);
}
.red {
    background-color: rgba(255, 171, 157, .5);
}
.purple {
    background-color:rgba(205, 185, 243, .5);
}
.selected {
    background-color:#fff5aa !important;
}
.given {
    font-weight: bold;
}
.obstacle {
    width: 100%;
    height: 100%;
}
.tooltip-spacer {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 0px;
    left: 0px;
    transform: translate(-100px, -110%);
    z-index: 9999;
}
.item-tooltip {
    color: white;
    font-size: 16px;
    padding: 6px 8px;
    white-space: nowrap;
    background:rgba(0,100,155, .9);
    border-radius:3px;
    z-index: 9999;
}
.redText {
    color: red;
}
.greenText {
    color: green;
}
</style>